<template lang="pug">
.container-auth
    //- img.logo-global(alt="Vue logo" src="./../../assets/logo-vw.svg")
    //- img.logo-global(alt="Vue logo" src="./../../assets/logo-bin.png")
    img.logo-global(alt="Vue logo" :src="logo")
    //- img.logo-global(alt="Vue logo" src="@/assets/no-image.png")
    .box.mb-2
        .box__header
            h2.heading.pl-2 Login
        .box__body.p-6
            //- form(action="" method="")
            form
                .field.mb-4
                    .form-group
                        label.block.text-sm.font-bold.mb-2(for="field") Email
                        input.field-style(id="username" type="email" placeholder="Email" v-model="username" required)
                    .error(v-if="error_username !== null") {{ error_username }}
                .field.mb-8
                    .form-group
                        label.block.text-sm.font-bold.mb-2(for="field") Password
                        input.field-style(id="password" type="password" placeholder="Password" v-model="password" required)
                    .error(v-if="error_password !== null") {{ error_password }}
                .flex.items-center.justify-between
                        button.btn-primary.btn-large(type='submit' @click="handleLogin")
                            Strong LOGIN
                        //- button.btn-default(type='button') Forgot Password
                        //- a.btn-default Forgot Password
                        //- router-link.btn-default(to="forgot-password") Forgot Password
                        span.btn-default.cursor-pointer(@click="forgotPassword()") Forgot Password
    span.text-gray-500.text-xs.text-center.block © {{ app_name }} {{ new Date().getFullYear() }}
            
</template>

<script>
export default {
    name: 'PageLogin',
    data(){
        return {
            // app_name: process.env.VUE_APP_APP_NAME,
            // logo: process.env.VUE_APP_APP_LOGO,
            app_name: this.$store.getters.getTitleGlobal,
            logo: this.$store.getters.getLogo,
            username : "",
            password : "",
            error_username : null,
            error_password: null,
        }
    },
    methods : {
        validateEmail(email) {
            /* eslint-disable no-useless-escape */
            const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        forgotPassword() {
            this.$swal.fire({
                icon: 'info',
                title: 'Please contact admin to reset password!',
                // text: id,
                showConfirmButton: true,
                // confirmButtonText: 'Yes!',
                // confirmButtonColor: '#DD6B55',
                showCancelButton: false,
                // allowOutsideClick: false,
            });
        },
        handleLogin(e){
            e.preventDefault();

            this.error_username = null;
            this.error_password = null;

            if (this.username.length === 0 || this.password.length === 0) {
                // alert('Username and password is required!');
                this.error_username = (this.username.length==0 ? 'Email is required.' : null);
                this.error_password = (this.password.length==0 ? 'Password is required.' : null);

                this.$swal.fire({
                    title: 'Username or password is required!',
                    icon: 'warning',
                    timer: 3000,
                });
                return;
            }

            // if use email
            if (!this.validateEmail(this.username)) {
                this.error_username = 'The email must be a valid email address.';
                this.$swal.fire({
                    title: 'Email must be a valid email address.',
                    icon: 'warning',
                    timer: 3000,
                });
                return;
            }

            // loading
            this.$swal.fire({
                title: '',
                html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                showConfirmButton: false,
                allowOutsideClick: false
            });

            // ----------------------------------------------------------------

            if (process.env.VUE_APP_AUTH_TYPE === 'local') {
                // with local auth
                if ((this.username === process.env.VUE_APP_LOCAL_AUTH_USERNAME || this.username === process.env.VUE_APP_LOCAL_AUTH_EMAIL) && this.password === process.env.VUE_APP_LOCAL_AUTH_PASSWORD) {

                    // before auth api
                    // localStorage.setItem('local_auth_token', process.env.VUE_APP_LOCAL_AUTH_TOKEN);

                    // after auth api
                    // localStorage.setItem('auth_token', process.env.VUE_APP_LOCAL_AUTH_TOKEN);

                    // temporary for api error
                    var auth_data = {
                        "user": {
                            "id": "15d17977-7005-4f82-8d2a-33bd27cad2a8",
                            "name": "Superadmin",
                            "email": "superadmin@gmail.com",
                            "status": 1,
                            "created_at": "2020-05-18 01:54:16+0000",
                            "updated_at": "2020-05-18 01:54:16+0000",
                            "role": {
                                "id": 1,
                                "name": "Superadmin",
                                "label": "superadmin",
                                "status": 1,
                                "description": "",
                                "function": [
                                    {
                                        "id": 2,
                                        "name": "Create",
                                        "key": "create"
                                    },
                                    {
                                        "id": 13,
                                        "name": "ACL",
                                        "key": "acl"
                                    }
                                ]
                            },
                            "photo": "",
                            "client": {
                                "id": 1,
                                "name": "Tlab",
                                "key": "tlab",
                                "secret": "tlab",
                                "status": 1,
                                "description": ""
                            }
                        },
                        "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiMTVkMTc5NzctNzAwNS00ZjgyLThkMmEtMzNiZDI3Y2FkMmE4IiwidXNlcm5hbWUiOiJjMTk0ZmJjMi00ODZhLTQzNDYtYmYwNi1lMjNlZGNlZDcyN2EiLCJleHAiOjE1ODk3NzA0ODIsImVtYWlsIjoic3VwZXJhZG1pbkBnbWFpbC5jb20ifQ.fsiiPtAgwIXn7Mje_P15GIsGJX8gyM9SRfD2QMLc1zU"
                    };

                    this.$store.commit('setAuthToken', auth_data.token);
                    this.$store.commit('setAuthData', auth_data.user);

                    this.$swal.fire({
                        title: 'Welcome, '+ process.env.VUE_APP_LOCAL_AUTH_USERNAME +'!',
                        icon: 'success',
                        timer: 3000,
                    });

                    this.$router.push({ name: 'PageDashboard' });

                    this.username = '';
                    this.password = '';
                    document.getElementById('username').focus();
                } else {
                    // alert('Username or password is wrong!');

                    this.error_username = 'Username or password is wrong';
                    this.$swal.fire({
                        title: 'Username or password is wrong!',
                        icon: 'error',
                        // timer: 3000,
                    });
                }

            } else if (process.env.VUE_APP_AUTH_TYPE === 'api') {

                // with auth api
                this.$store.dispatch('getLogin', [this.username, this.password])
                .then((resp) => {

                    // console.log('after login request login in Login.vue');
                    // console.log(resp)

                    if (resp.result === 'success') {

                        this.$router.push({ name: 'PageDashboard' });

                        // this.$swal.close();
                        this.$swal.fire({
                            title: 'Welcome, '+ resp.data.name +'!',
                            icon: 'success',
                            timer: 3000,
                        });

                        this.username = '';
                        this.password = '';
                        this.error_username = null;
                        this.error_password = null;

                        document.getElementById('username').focus();
                    } else {
                        
                        this.error_username = (resp.data && resp.data.message ? resp.data.message : null);

                        this.$swal.fire({
                            icon: 'error',
                            title: 'Failed login!',
                            text: (resp.data && resp.data.message ? resp.data.message : 'Something wrong.'),
                            // timer: 3000,
                        });
                    }
                });
            } else {
                this.$swal.fire({
                    title: 'Failed login!',
                    icon: 'error',
                    text: 'There is no auth type configuration in .env.',
                    // timer: 3000,
                });
            }
        }
    },
    mounted() {
        document.getElementById('username').focus();
    },
}
</script>

<style lang="sass" scoped>
.container-auth
    max-width: 420px
    margin: 32px auto

    .logo-global
        max-width: 150px
        margin: 0 auto 24px auto
    button.btn-primary
        letter-spacing: 1px

// error field
.error 
    color: red

</style>
